module.exports = __webpack_public_path__ + "e-learning-app/static/img/fourstartpc.24f5c58.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/fourstartpc.jpg
// module id = +AC8
// module chunks = 1